import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'

import PerformanceTable from './PerformanceTable'
import Spinner from '@components/spinner'
import Error from '@components/Error/NoContent'
import Scroll from '@components/Scroll'

class PerformanceView extends Component {
  static propTypes = {
    performanceStore: PropTypes.object
  }

  constructor (props) {
    super(props)
    this.loadInitialData()
  }

  loadInitialData () {
    this.props.performanceStore.filter()
  }

  renderError (error) {
    if (error) return <Error />
  }

  renderLoader () {
    return <Spinner />
  }

  render () {
    const { loading, error, performances, query } = this.props.performanceStore
    if (error) {
      return this.renderError(error)
    }
    if (loading) {
      return this.renderLoader()
    }

    return (
      <div className='revenues-view'>
        <Scroll>
          <div className='project-wrapper'>
            <div className='details-header'>
              <div className='info info--noLeft'>
                <div className='name-status-wrapper'>
                  <h1>Performance</h1>
                </div>
              </div>
            </div>
            {performances.length ? (
              <div className='invoice-wrapper animate-intro'>
                <PerformanceTable
                  performances={performances}
                  showTotal={!!query.employeeId}
                />
              </div>
            ) : (
              <Error label={'No results match the current filter parameters'} />
            )}
          </div>
        </Scroll>
      </div>
    )
  }
}

export default inject('performanceStore')(observer(PerformanceView))
